import { Tooltip, TooltipProps } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import React from "react";

interface IProps extends TooltipProps {}

const InfoTooltipComponent: React.FC<IProps> = ({ children, ...rest }) => {
  return (
    <Tooltip {...rest}>
      <InfoOutlined />
    </Tooltip>
  );
};

InfoTooltipComponent.defaultProps = {
  placement: "bottom",
};

export default InfoTooltipComponent;
